<template>
  <v-container class="neat-container">
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="(head, index) in headers"
              :key="index"
              class="table-head"
            >
            {{ head }}
            </th>
            <th
              class="d-flex align-items-center justify-content-end"
              >
              <v-btn v-if="checkable"
              color="#033e8c"
              height="25px"
              depressed
              dark
              @click="selectAllParts"
              > <small> toggle </small> </v-btn>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="part in parts"
            :key="part.part_id"
            @click="rowClicked(part.part_id)"
          >
            <td>
              {{ part[displayItems[0]] }}
            </td>
            <td v-if="!checkable">
              {{ part[displayItems[1]] ? part[displayItems[1]] : '' }}
            </td>
            <td align="right">
              <element v-if="checkable">
                
                <v-icon v-if="selectedPartsIds.includes(part.part_id)" color="#33ee33" large>mdi-check</v-icon>
                <v-icon v-else color="#ee0000" large>mdi-close</v-icon>
                
              </element>
              <v-icon v-else>mdi-information-variant</v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
export default {
  name: "PartTable",
  props: {
    checkable: Boolean,
    headers: Array,
    parts: Array,
    selectedPartsIds: Array,
    displayItems: {
      type: Array,
      default: function () {
      // td 202008241917 updated serial_number to oem_number
        return ['name', 'oem_number']
      }
    },
  },
  data() {
    return {
      checkedItems: [],
    }
  },
  methods: {
    rowClicked(partId) {
    //console.log('rowClicked: ', partId)
      if (this.checkedItems.includes(partId)) {
        this.checkedItems = this.checkedItems.filter(item => item === partId)
      } else {
        this.checkedItems.push(partId)
      }

      this.$emit('rowClick', partId)
    },
    selectAllParts(){
      // we select all parts that are currently displayed (filtered or not)
      this.$emit('onSelectAllParts');
    }
  },
}
</script>

<style scoped>

</style>
